const STORAGE_KEY = "digital_twin_voice_samples";

export const fileToBase64 = (
  file: File
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () =>
      resolve(reader.result as string);

    reader.onerror = reject;
  });
};

export const base64ToFile = async (
  base64: string,
  filename: string
): Promise<File> => {
  const res = await fetch(base64);

  const blob = await res.blob();

  return new File([blob], filename, {
    type: "audio/webm",
  });
};

export const saveVoiceSample = async (
  audioBlob: Blob
) => {
  try {
    const existingSamples = JSON.parse(
      sessionStorage.getItem(STORAGE_KEY) || "[]"
    );

    // limit to 2 recordings
    if (existingSamples.length >= 2) {
      return existingSamples.length;
    }

    const audioFile = new File(
      [audioBlob],
      `voice_sample_${Date.now()}.webm`,
      { type: "audio/webm" }
    );

    const base64Audio = await fileToBase64(audioFile);

    existingSamples.push(base64Audio);

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(existingSamples)
    );

    return existingSamples.length;

  } catch (err) {
    console.error(
      "Failed to save voice sample",
      err
    );

    return 0;
  }
};

export const getVoiceSamples = (): string[] => {
  try {
    return JSON.parse(
      sessionStorage.getItem(STORAGE_KEY) || "[]"
    );
  } catch {
    return [];
  }
};

export const clearVoiceSamples = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const getVoiceSampleCount = (): number => {
  return getVoiceSamples().length;
};

export const hasEnoughVoiceSamples = (): boolean => {
  return getVoiceSampleCount() >= 1;
};